import * as amplitude from '@amplitude/analytics-browser';
import { get, castArray } from 'lodash';
import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { TextInput } from '@hivebrite/design-system/Inputs';
import { toast } from '@hivebrite/design-system/Toast';

import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const PromoCodeValidation = () => {
  const {
    actions: {
      items: { addPromoCode },
    },
    isLoading,
  } = useShoppingCard();
  const [code, setCode] = useState('');

  const { flagEvPaymentsMovePromocode } = useFeatureFlag();

  const onSubmit = async () => {
    try {
      amplitude.track(`OrderManagement|PromoCodeInserted`, {
        location: flagEvPaymentsMovePromocode
          ? 'Sidebar'
          : 'Billing Information Step',
      });

      await addPromoCode(code);
      toast.success(
        s__('Memberships|Your promo code has been entered successfully!'),
      );
    } catch (error) {
      const errorMessage = castArray(
        get(error, ['response', 'data', 'errors_full_messages']),
      );

      toast.error(errorMessage.join(' - '));
    } finally {
      setCode('');
    }
  };

  if (flagEvPaymentsMovePromocode) {
    return (
      <>
        <Box font="h3-semibold" mb={3}>
          {s__('OrderManagement|Promo code')}
        </Box>
        <Box alignItems="center" flexWrap="wrap">
          <Box mb={5} width="300px" mr={6}>
            <TextInput
              id="promo_code"
              name="promo_code"
              value={code}
              onChange={(event) => setCode(event.target.value.toUpperCase())}
              placeholder={s__('OrderManagement|Insert promo code')}
              clearable
            />
          </Box>
          <Button onClick={onSubmit} isLoading={isLoading} isDisabled={!code}>
            {s__('OrderManagement|Use promo code')}
          </Button>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box font="body-regular-asphalt" mb={3}>
        {s__(
          'Memberships|Do you have any promotional codes to add to your order?',
        )}
      </Box>
      <Box alignItems="center" flexWrap="wrap">
        <Box mb={6} width="300px" mr={6}>
          <TextInput
            id="promo_code"
            name="promo_code"
            value={code}
            onChange={(event) => setCode(event.target.value.toUpperCase())}
            placeholder={s__('Memberships|Insert promo code')}
            label={s__('Memberships|Promo code')}
            clearable
          />
        </Box>
        <Button onClick={onSubmit} isLoading={isLoading} isDisabled={!code}>
          {s__('Memberships|Use promo code')}
        </Button>
      </Box>
    </>
  );
};

export default PromoCodeValidation;
